import * as React from 'react';
import { userTypeEnums} from '../features/shared/enums';

import {Button} from 'ukas.uux.react-components';

// const PearsonElementsSDK = require('@pearson-components/elements-sdk/build/dist.elements-sdk');

interface ConfirmationModalProps {
    cancelBtnHandler : ( event: React.UIEvent<HTMLSpanElement>) => void;
    userType: string;
    isAccountLocked: boolean
}


const AccessDeniedModal = ({ cancelBtnHandler, userType , isAccountLocked }: ConfirmationModalProps, ) =>{
  const errorMessageFragment = (userType.toUpperCase() === userTypeEnums.EXTERNAL_USER.toUpperCase())
    ? <> Your account might be locked please contact  
      <a target="_blank" href="https://qualifications.pearson.com/en/contact-us/pearson-associate.html"> Associate Helpdesk.</a> </>
    : (userType.toUpperCase() === userTypeEnums.INTERNAL_USER.toUpperCase()) 
    ? 'Your account might be locked please raise an incident via myHelp.': 'Logging out...please wait';
  return ( <div>
        <div >
          <span>{errorMessageFragment}</span>
              </div> 
            <div className="pull-right"><br /><br />
            <Button
                onClick={cancelBtnHandler.bind(event)}
            >
                Close
            </Button>&nbsp;&nbsp;&nbsp;&nbsp;
            <p>&nbsp;</p>

      </div>
    </div>
     
      
   
  );
};

export default AccessDeniedModal;
